'use client';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { pluralize } from '../../../util/str.js';
import { BaseEventBanner } from '../base-event-banner/base-event-banner.js';

const CohortBanner = ({ description, numSessions, eventUrl, title, coaches, onClick, time, }) => {
    return (jsx(BaseEventBanner, { time: time, title: title, coaches: coaches, eventUrl: eventUrl, topLeft: jsxs(Fragment, { children: [jsx("span", { children: "Cohort-Based Course" }), jsx("span", { className: "hidden sm:block", children: "\u00B7" }), jsx("span", { children: pluralize(numSessions, 'Session') })] }), description: description, onClick: onClick, ctaLabel: "Learn more" }));
};

export { CohortBanner };
//# sourceMappingURL=cohort-banner.js.map
